import * as Stimulus from "@hotwired/stimulus"

export class PollResultsController extends Stimulus.Controller {
    static get targets() {
        return ["pendingRecord"];
    }

    static values = {
        pollIntervalSeconds: { type: Number, default: 10 },
        timerId: { type: String, default: null },
        blockPolling: { type: Boolean, default: false }
    }

    disconnect() {
        clearTimeout(this.timerIdValue);
        this.timerIdValue = null;
    }

    pendingRecordTargetConnected() {
        this.runPolling()
    }

    runPolling() {
        if(this.#pendingRecordCount() > 0 && !(this.timerIdValue > 0)) {
            this.timerIdValue = setTimeout(() => { this.#poll() }, this.pollIntervalSecondsValue * 1000)
        }
    }

    blockPolling() {
        this.blockPollingValue = true;
    }

    unblockPolling() {
        this.blockPollingValue = false;
    }

    #pendingRecordCount() {
        // Count the pendingRecord targets using querySelectorAll()
        // because Stimulus seems to be unable to maintain an accurate
        // count when a turbo frame is on the page and things change
        // within it (e.g. pagination, filtering)
        return document.querySelectorAll('[data-poll-results-target=pendingRecord]').length
    }

    #poll() {
        this.timerIdValue = null;
        if(this.#pendingRecordCount() == 0) {
            return;
        }
        if(this.blockPollingValue) {
            clearTimeout(this.timerIdValue);
            this.runPolling();
            return;
        }
        Turbo.visit(window.location.href, {frame: this.element.id})
    }


}

